export enum BioExamsStatuEnum {
  LEGISLACAO_APTO = 'APTO',
  LEGISLACAO_INAPTO = 'INAPTO',
  DIRECAO_VEICULAR_APTO = 'APTO',
  DIRECAO_VEICULAR_INAPTO = 'INAPTO'
}
